import { useCurrentUser } from "@/libs/apis/onboarding/useUser";
import { useCurrentUserNftsWithFavorites } from "../hooks/useNftsWithFavorites";
import { useUserNFTs } from "../services/useUserNFTs/useUserNFTs";
import { NFTContract } from "../types";
import ProductCardWrapper from "./ProductCardWrapper";

type Props = { swooshHandle: string };

const ProductCards: React.FC<Props> = ({ swooshHandle }) => {
  const { data } = useUserNFTs(swooshHandle);
  const { currentUser } = useCurrentUser();

  const userNfts = data?.nfts;
  const { nftsWithFavorites } = useCurrentUserNftsWithFavorites(
    userNfts as NFTContract[],
  );

  if (userNfts === undefined) return null;

  const isCurrentUsersProfile = swooshHandle === currentUser?.swooshHandle;

  return (
    <div className="gap-sm items-start md:gap-base grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
      {nftsWithFavorites?.map((nft) => (
        <ProductCardWrapper
          key={nft.tokenId}
          nft={nft}
          swooshHandle={swooshHandle}
          isFavorited={!!nft.isFavorited}
          enabledTokenTransfer={isCurrentUsersProfile}
        />
      ))}
    </div>
  );
};

export default ProductCards;
